import { type GetV2ApiCompanyIdSpendLimitsSpendLimitIdResponseOK } from 'src/client/spendesk-api-types';

const spendLimitPeriods = ['day', 'week', 'month', 'year', 'request'] as const;

export type SpendLimitPeriod = (typeof spendLimitPeriods)[number];

export type SpendLimit = {
  active: boolean;
  assignees: { users: Array<string> } | null;
  autoApproveWithinLimit: boolean;
  autoRejectOverLimit: boolean;
  customFieldValueId: string;
  id: string;
  isDefault: boolean;
  limits: {
    day?: number;
    month?: number;
    request?: number;
    week?: number;
    year?: number;
  };
  name?: string;
};

export const mapSpendLimitResponseToSpendLimit = (
  spendLimit: GetV2ApiCompanyIdSpendLimitsSpendLimitIdResponseOK,
): SpendLimit => {
  return {
    active: spendLimit.active,
    assignees: spendLimit.assignees,
    autoApproveWithinLimit: spendLimit.autoApproveWithinLimit,
    autoRejectOverLimit: spendLimit.autoRejectOverLimit,
    customFieldValueId: spendLimit.customFieldValueId,
    id: spendLimit.id,
    isDefault: spendLimit.isDefault,
    limits: spendLimit.limits,
    name: spendLimit.name,
  };
};

// Individual period status structure
export type SpendLimitPeriodStatus = {
  currency: string;
  from: string;
  impactingSpends: { paymentCount: number; requestCount: number };
  limitAmount: number;
  period: SpendLimitPeriod;
  to: string;
  usedAmount: number;
};

export type SpendLimitRule = {
  amount: number | undefined;
  period: SpendLimitPeriod;
};

export type SpendLimitStatus = {
  spendLimitStatus: SpendLimitPeriodStatus[];
  spendLimit: SpendLimit;
};
